import { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast,
  FormHelperText,
} from '@chakra-ui/react';

const initialFormData = {
  name: '',
  url: '',
};

function SiteModal({ isOpen, onClose, onSubmit, site, isLoading }) {
  const [formData, setFormData] = useState(initialFormData);
  const toast = useToast();
  const isEditing = !!site;

  useEffect(() => {
    if (site) {
      setFormData({
        name: site.site_name || site.name || '',
        url: site.site_url || site.url || '',
      });
    } else {
      setFormData(initialFormData);
    }
  }, [site, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast({
        title: 'Site name is required',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    if (!formData.url.trim()) {
      toast({
        title: 'Site URL is required',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    // Basic URL validation
    let url = formData.url.trim();
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }

    await onSubmit({
      name: formData.name.trim(),
      url: url,
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent borderRadius="2xl" mx={4}>
        <form onSubmit={handleSubmit}>
          <ModalHeader>{isEditing ? 'Edit Site' : 'Add New Site'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <FormControl isRequired>
                <FormLabel>Site Name</FormLabel>
                <Input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="e.g., My Website"
                  borderRadius="xl"
                />
                <FormHelperText>A friendly name to identify this site</FormHelperText>
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Site URL</FormLabel>
                <Input
                  name="url"
                  value={formData.url}
                  onChange={handleChange}
                  placeholder="e.g., example.com"
                  borderRadius="xl"
                />
                <FormHelperText>The domain where tracking will be installed</FormHelperText>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter gap={3}>
            <Button variant="ghost" onClick={onClose} borderRadius="xl">
              Cancel
            </Button>
            <Button
              type="submit"
              colorScheme="brand"
              isLoading={isLoading}
              borderRadius="xl"
            >
              {isEditing ? 'Save Changes' : 'Add Site'}
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}

export default SiteModal;
